import useBackgroundManager from '@hooks/useBackgroundManager';
import useHostJoinListener from '@hooks/useHostJoinListener';
import useTicketCreatedListener from '@hooks/useTicketCreatedListener';
import HeaderButton from '@molecules/HeaderButton';
import { defaultBack } from '@utils/navigation';
import { headerOptionsCreator } from '@utils/screenOptions';
import { Stack } from 'expo-router';
import React from 'react';

export default function ScreenStack() {
  useBackgroundManager();
  useHostJoinListener();
  useTicketCreatedListener();

  return (
    <Stack screenOptions={headerOptionsCreator(<HeaderButton />)}>
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen name="profile" options={{ headerShown: false }} />
      <Stack.Screen name="introduce" />
      <Stack.Screen name="greenRoom" />
      <Stack.Screen name="watch" />
      <Stack.Screen name="to/[userId]" />
      <Stack.Screen
        name="newMessage"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/inbox/all')} />,
        )}
      />
      <Stack.Screen name="editProfile/index" />
      <Stack.Screen
        name="editProfile/prep"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/editProfile')} />,
        )}
      />
      <Stack.Screen
        name="editProfile/record"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/editProfile/prep')} />,
        )}
      />
      <Stack.Screen
        name="editProfile/preview"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/editProfile/prep')} />,
        )}
      />
      <Stack.Screen
        name="live/[eventId]"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="sessions/review/[sessionId]"
        options={headerOptionsCreator()}
      />
      <Stack.Screen name="voting/[eventId]" options={headerOptionsCreator()} />
      <Stack.Screen name="communities/[communitySlug]" />
      <Stack.Screen name="community/[communitySlug]" />
      <Stack.Screen name="events/[slug]" />
      <Stack.Screen name="tickets/group/[slug]" />
      <Stack.Screen name="login" options={headerOptionsCreator(undefined)} />
    </Stack>
  );
}

export const unstable_settings = {
  initialRouteName: '(tabs)/events/index',
};
